import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { StreamingChartInfo } from '@/@types/graphql-types';

import TitleDetailChartInfoV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailChartInfoV1.vue';
import TitleDetailPosterInfoV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailPosterInfoV1.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ThumborOptions } from '@/filters/thumbor';
import Vue from 'vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailPosterWithInfo',
  props: {
    showChartInfo: { type: Boolean },
    streamingChartInfo: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
	showChartInfo: boolean;
	streamingChartInfo?: StreamingChartInfo | null;
	title: TitleDetail;
};



const titleName = computed(() => {
	if (props.title.__typename === 'Season') {
		return props.title.show.content.title + ' - ' + props.title.content.title;
	}
	return props.title.content.title;
});

const imgSrc = computed(() => {
	return Vue.filter('Thumbor')({
		url: props.title.content.posterUrl,
		imageType: 'poster_global',
	} as ThumborOptions);
});

return { __sfc: true,props, titleName, imgSrc, TitleDetailChartInfoV1, TitleDetailPosterInfoV1, PictureComp }
}

})